import { useState } from "react";
import { Popover } from "antd";

import { DropdownMenuProps } from "./types";

import "./styles.css";

const DropdownMenu = ({
  children,
  title,
  content,
  ...props
}: DropdownMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (newIsOpen: boolean) => {
    setIsOpen(newIsOpen);
    props.onOpenChange?.(newIsOpen);
  };

  return (
    <Popover
      content={<div onClick={() => handleOpenChange(false)}>{content}</div>}
      title={title}
      trigger="click"
      rootClassName="dropdown-menu-popover"
      {...props}
      open={isOpen}
      onOpenChange={handleOpenChange}
    >
      {children}
    </Popover>
  );
};

export default DropdownMenu;
